// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"479":"17565a88","946":"d0d9b8bd"}[chunkId] + ".chunk.js";
};